import { Component, Input } from '@angular/core';
import { environment } from '@core/envs';
import { AuthService } from '@agenda-customer-ui/data-access';
import { isSourceFordPass, isSourcePerks } from '@core/utils';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonLibComponent } from '@components/atoms';
import { NgIf } from '@angular/common';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-no-content',
    templateUrl: './no-content.component.html',
    styleUrls: ['./no-content.component.scss'],
    standalone: true,
    imports: [NgIf, ButtonLibComponent, TranslateModule]
})
export class NoContentComponent {

  @Input()
  type!: string;
  @Input()
  vin!: string;
  isFordPass = isSourceFordPass(this.authService.urlInfo.source);
  isPerks = isSourcePerks(this.authService.urlInfo.source);

  constructor (private authService: AuthService) { }

  // TODO: precisa trocar esse redirect nao mandar pra url do schedule e sim para o projeto remote
  public redirectTo(): void {
    const urlParams = `?&cat=${this.authService.tokens.cat}&divisionId=1&vin=${this.vin}&country=${this.authService.urlInfo.country}&dealerId=&source=${this.authService.urlInfo.source}`;
    window.location.href = environment.project.schedule+urlParams;
  }
}
